export class ServiceGroupRateQueryParameters {
  effectiveDate?: Date;
  expiryDate?: Date;
  id?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string;
  serviceGroupId?: string;

  constructor(obj?: ServiceGroupRateQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
